module.exports = __webpack_public_path__ + "img/70.4.NH3-N.c2871041.png";